import { Box, Typography } from '@mui/material'

export const UnAuthorized: React.FC = () => {
    return (
        <Box style={{ height: '80vh', width: '100%', backgroundColor: '#F2F6F9' }}>
            <Box
                style={{
                    height: '40vh',
                    justifyContent: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    borderRadius: '10px',
                    marginTop: '10%',
                    padding: '30px',
                    backgroundColor: '#00253F',
                }}
            >
                <Typography
                    color="white"
                    style={{
                        fontWeight: '400',
                        fontSize: '16px',
                        marginLeft: '15px',
                        marginRight: '15px',
                    }}
                >
                    401 Unauthorized
                </Typography>
                <Typography
                    color="white"
                    style={{
                        fontWeight: '400',
                        fontSize: '12px',
                        marginLeft: '15px',
                        marginRight: '15px',
                        cursor: 'pointer',
                    }}
                    onClick={() => (window.location.href = '/oauth/logout')}
                >
                    Return to login
                </Typography>
            </Box>
        </Box>
    )
}
